import React from 'react'

/* Red de seguridad de RENDER: si una vista lanza durante el render, React
   desmonta TODO el arbol y queda la pantalla blanca. Este boundary corta la
   caida, muestra el error real (mensaje + stack) y deja seguir trabajando
   sin recargar a ciegas. */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null, info: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    this.setState({ info })
    // eslint-disable-next-line
    console.error('[ErrorBoundary]', this.props.zone || '', error, info && info.componentStack)
  }

  render() {
    const { error, info } = this.state
    if (!error) return this.props.children
    return (
      <div style={{ maxWidth: 860, margin: '40px auto', padding: '0 16px', fontFamily: 'inherit' }}>
        <div style={{ background: '#fff', border: '1px solid #fecaca', borderRadius: 10, overflow: 'hidden', boxShadow: '0 8px 24px rgba(15,23,42,.08)' }}>
          <div style={{ background: '#fef2f2', borderBottom: '1px solid #fecaca', padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 22 }}>🛟</span>
            <div>
              <div style={{ fontWeight: 700, color: '#991b1b', fontSize: 15 }}>La vista se rompió, pero no perdiste nada</div>
              <div style={{ color: '#b45309', fontSize: 12.5 }}>
                {this.props.zone ? 'Zona: ' + this.props.zone + ' · ' : ''}El resto de la app sigue vivo; tu trabajo (biblioteca, cola dev, config) está guardado en el navegador.
              </div>
            </div>
          </div>
          <div style={{ padding: '14px 18px' }}>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 6 }}>Error de render:</div>
            <pre
              style={{
                margin: 0,
                padding: '10px 12px',
                background: '#0f172a',
                color: '#fca5a5',
                borderRadius: 6,
                fontSize: 12,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                maxHeight: 180,
                overflow: 'auto',
              }}
            >
              {String((error && (error.message || error)) || 'Error desconocido')}
            </pre>
            {info && info.componentStack ? (
              <details style={{ marginTop: 10 }}>
                <summary style={{ cursor: 'pointer', fontSize: 12, color: '#64748b' }}>Ver componente que falló (para reportarlo)</summary>
                <pre style={{ margin: '8px 0 0', padding: '10px 12px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 6, fontSize: 11, maxHeight: 200, overflow: 'auto', color: '#475569' }}>
                  {info.componentStack}
                </pre>
              </details>
            ) : null}
            <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
              <button
                type="button"
                onClick={() => this.setState({ error: null, info: null })}
                style={{ background: '#16a34a', color: '#fff', border: 0, borderRadius: 6, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
              >
                ↩ Reintentar la vista
              </button>
              <button
                type="button"
                onClick={() => window.location.reload()}
                style={{ background: '#fff', color: '#334155', border: '1px solid #cbd5e1', borderRadius: 6, padding: '8px 16px', fontSize: 13, cursor: 'pointer' }}
              >
                ⟳ Recargar la página
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ErrorBoundary
